// eslint-disable-next-line boundaries/element-types
import { AssetCardProps } from 'features/assetDatabase'
// eslint-disable-next-line boundaries/element-types
import { AssetImageGenerator } from 'features/assetViz'
import React from 'react'

interface AssetTableAssetVizProps {
  unitID: string
  siteID: string
  cardProps: AssetCardProps | undefined
}

const AssetTableAssetViz: React.FC<AssetTableAssetVizProps> = (props) => {
  const { unitID, cardProps } = props
  return (
    <>
      {cardProps?.unit && (
        <AssetImageGenerator
          assetVizID={unitID}
          unit={cardProps.unit}
          assetModel={cardProps?.assetModel}
          component={cardProps?.component}
          colorThreshold={cardProps?.colorThreshold}
          componentDataFrame={cardProps?.componentDataFrame}
        />
      )}
    </>
  )
}

export default AssetTableAssetViz
